/**
 * Helper variables
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const body            = document.querySelector( 'body' );
export const header          = document.querySelector( '.c-header' );
export const headerLogo      = document.querySelector( '.c-logo' );
export const isUserLoggedIn  = body.classList.contains( 'logged-in' );
export const wpAdminBarSpace = isUserLoggedIn ? 32 : 0;
export const viewportWidth   = window.innerWidth || document.documentElement.clientWidth;
export const windowWidth     = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 )
export const windowHeight    = Math.max( document.documentElement.clientHeight || 0, window.innerHeight || 0 )
export const isMobile        = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent )


/**
 * Helper Function to toggle between two classes using Vanilla JS
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const toggleCSSClasses = ( el, ...cls ) => cls.map( cl => el.classList.toggle( cl ) );


/**
 * Helper Function to add commas to numbers using Vanilla JS
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const numberWithCommas = x => x.toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );


/**
 * Helper Function to add commas to numbers using Vanilla JS
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const formulaPriceOutput = ( newPrice, priceMultiplier ) => Math.ceil( parseInt( newPrice * priceMultiplier ) / 10 ) * 10;


/**
 * Helper Function that finds the ancestor of a specific element
 *
 * @param el  - The element that is used as the point from where we start
 * @param sel - The element that we would like to target
 * @return void
 * @since  1.0.0
 * @access public
 */
export const findAncestor = ( el, sel ) => {
	while ( (el = el.parentElement) && !((el.matches || el.matchesSelector).call( el, sel )) ) ;
	return el;
};

/**
 * Helper Function that provides the sum of an array
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const arrSum = arr => arr.reduce( ( a, b ) => a + b, 0 );


/**
 * Helper Function that provides the closest selector
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const getClosest = function ( elem, selector ) {
	// Element.matches() polyfill
	if ( !Element.prototype.matches ) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			function ( s ) {
				var matches = (this.document || this.ownerDocument).querySelectorAll( s ),
					i       = matches.length;
				while ( --i >= 0 && matches.item( i ) !== this ) {
				}
				return i > -1;
			};
	}

	// Get the closest matching element
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;
};


/**
 * Helper Function that adds an event listener only if El exists
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const addEventListenerIfElExists = function ( el, targetFunction ) {
	if ( document.body.contains( el ) ) {
		el.addEventListener( 'click', targetFunction );
	}
}

/**
 * Show an element
 *
 * @param elem
 */
export const show = function ( elem ) {
	elem.style.display = 'block';
};

/**
 * Hide an element
 *
 * @param elem
 */
export const hide = function ( elem ) {
	elem.style.display = 'none';
};
